import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren, } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DashboardService } from '../../../business-services/dashboard.service';
import { AdditionalWorkReportService } from '../../../business-services/additional-work-report.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { NgbdSortableHeader, SortEvent, } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { AdditionalWorkResponseModel, StatusViewModel } from '../../../business-entities/additional-work-report.model';
import { PagerData } from '../../../business-entities/PagerData';
import { Filter } from '../../../business-entities/Filter';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { PaginationService } from '../../../services/pagination.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-additional-work-report',
  templateUrl: './additional-work-report.component.html',
})

export class AdditionalWorkReportComponent implements OnInit {

  //#region Properties
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  dealers: any[] = [];
  dealerId: string;
  selectedStatus: number;
  totalCount = 0;
  selectedDate: any[] = [];
  isRequired = false;
  StatusList: StatusViewModel[] = [];
  additionalWorkList: AdditionalWorkResponseModel[] = [];
  dataList: AdditionalWorkResponseModel[] = [];
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  scrollDistance = 1;
  throttle = 10;
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  //#endregion

  //#region Constructor
  constructor(
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private toaster: ToastrService,
    private dashboardService: DashboardService,
    private translate: TranslateService,
    private userService: UserDataService,
    private excelService: ExcelService,
    private additionalWorkService: AdditionalWorkReportService,
    private pageService: PaginationService,
  ) { }
  //#endregion

  //#region Angular methods
  async ngOnInit(): Promise<void> {
    this.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.userService.currentUser.subscribe(user => {
      if (user) {
        this.getDealers(user.id);
      }

    });
    this.StatusList = this.dashboardService.getAdditionalWorkStatusList();
    this.selectedStatus = Enums.AdditionalWorkStatus.All;
    this.setDefaultDateRange();
  }

  private async getDealers(userId: string): Promise<void> {
    this.spinner.show();
    try {
      this.dealers = await this.dashboardService.GetDealers(userId);
    } finally {
      this.spinner.hide();
    }
  }

  private setDefaultDateRange(): void {
    let todayDate = new Date();
    let formattedTodayDate = this.datePipe.transform(todayDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(todayDate);
    this.selectedDate.push(todayDate);
    let formatted= formattedTodayDate + ' - ' + formattedTodayDate;
    this.additionalWorkService.additionalWorkRequestModel.selectedDate = formatted;
  }

  public onDateRangeChanged(event) {
    this.selectedDate = (typeof event === 'undefined') ? [] : event;
    let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    if (selectedDateFormatted == "") {
      this.onDateSelectionCleared();
    }
    this.additionalWorkService.additionalWorkRequestModel.selectedDate = selectedDateFormatted;
  }

  public async onDealerChanged(value) {
    if (value) {
      this.isRequired = false;
      this.additionalWorkService.additionalWorkRequestModel.dealerId = this.dealerId;
    } else {
      this.isRequired = true;
    }
  }

  public async clearSearch() {
    this.dealerId = null;
    this.selectedStatus = null;
    this.onDateSelectionCleared();
    this.totalCount = 0;
    this.additionalWorkList = [];
  }

  public async onSearchReport() {
    if (this.dealerId) {
      this.isRequired = false;
      this.totalCount = 0;
      this.additionalWorkList = [];
      await this.getAdditionalWorkList();
    } else {
      this.isRequired = true;
    }
  }

  async getAdditionalWorkList() {
    this.spinner.show();
    let selectedDateFormatted = this.getFormattedDate(this.selectedDate);
    this.additionalWorkService.additionalWorkRequestModel.selectedDate = selectedDateFormatted;
    await this.additionalWorkService.GetAdditionalWorkList(this.additionalWorkService.additionalWorkRequestModel)
      .then(
        (response) => {
          this.spinner.hide();
          this.additionalWorkList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            this.totalCount = this.additionalWorkList[0].totalCount;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.additionalWorkList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  async resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  async supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  async refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  async initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pageService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  async StatusChange(status: any) {
    if (status == undefined) {
      this.selectedStatus = Enums.AdditionalWorkStatus.All;
    }
    this.additionalWorkService.additionalWorkRequestModel.status = status
  }

  onScrollDown() {
    if (this.totalCount > this.additionalWorkList?.length) {
      this.additionalWorkService.additionalWorkRequestModel.startRecordNumber = this.additionalWorkList.length
      this.getAdditionalWorkList();
    }
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.additionalWorkService.additionalWorkRequestModel.sortColumn = column;
    this.additionalWorkService.additionalWorkRequestModel.sortDirection = direction;
    this.additionalWorkService.additionalWorkRequestModel.startRecordNumber = 0;
    this.additionalWorkList = [];
    this.getAdditionalWorkList();
  }
  
  private onDateSelectionCleared() {
    let warningmsg = this.translate.instant('lblShowingLastMonthData');
    this.toaster.warning(warningmsg);
    this.setLastMonthDates();
    this.cdr.detectChanges();
  }

  private setLastMonthDates() {
    const date = new Date();
    let startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    let endDate = new Date();
    this.selectedDate=[];
    this.selectedDate.push(startDate);
    this.selectedDate.push(endDate);
  }
  //#endregion

  //#region  Export functionality

  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblAdditionalWorkReport')}`);
    this.spinner.hide();
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('landscape');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8, cellPadding: { top: 2, right: 5, bottom: 2, left: 2 } },
      columnStyles: {
        9: { halign: 'right' }
      }
    });
    doc.save(`${this.translate.instant('lblAdditionalWorkReport')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    if (this.dealerId) {
      this.spinner.show();
      this.isRequired = false;
      this.additionalWorkService.additionalWorkRequestModel.isExport = true;
      await this.additionalWorkService.GetAdditionalWorkList(this.additionalWorkService.additionalWorkRequestModel).then((res) => {
        if (!res || res.responseObject.length === 0) {
          this.toaster.error(this.translate.instant('lblDataNotAvailable'));
          this.dataList = [];
          return;
        }
        this.dataList = res.responseObject;
      }).finally(() => {
        this.additionalWorkService.additionalWorkRequestModel.isExport = false;
        this.spinner.hide();
      })
    } else {
      this.isRequired = true;
      return;
    }
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblWoNo')]: item.workOrderNumber,
      [this.translate.instant('lblRegNumber')]: item.licensePlate,
      [this.translate.instant('lblWoStatus')]: item.workOrderStatus,
      [this.translate.instant('lblDealersName')]: item.dealerName,
      [this.translate.instant('lblCustomer')]: item.customerName,
      [this.translate.instant('lblCreatedDate')]: item.bookedDate ? this.datePipe.transform(new Date(item.bookedDate + 'Z'), 'dd-MM-yyyy', '') : null,
      [this.translate.instant('lblBillToCustomer')]: item.billToCustomer,
      [this.translate.instant('lblDemands')]: item.demandShortDescription,
      [this.translate.instant('lblTotalPrice')]: item.totalPrice,
      [this.translate.instant('lblStatus')]: item.status
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblRegNumber'),
      this.translate.instant('lblWoStatus'),
      this.translate.instant('lblDealersName'),
      this.translate.instant('lblCustomer'),
      this.translate.instant('lblBookedDate'),
      this.translate.instant('lblBillToCustomer'),
      this.translate.instant('lblDemands'),
      this.translate.instant('lblTotalPrice'),
      this.translate.instant('lblStatus'),
    ];
  }
  //#endregion
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}